import styled from 'styled-components'
import { sizes } from '../../util'

export const GroupBody = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 2rem 4rem;
  @media (max-width: ${sizes.medium}) {
    padding: 2rem;
  }
`
export const Group = styled.section`
  padding: 0 !important;
`
export const ShowItem = styled.section`
  padding: 0 !important;
  width: calc(100% / 1);
  margin: 0 0 5rem;
  background: none;
  /* z-index: 1; */
  font-size: 1.25rem;
  &:hover {
    background: none;
    /* color: ${props => props.theme.color}; */
  }
  h2 {
    font-weight: 400;
    /* color: ${props => props.theme.color}; */
    font-size: 2.25rem;
    &:hover {
      opacity: 0.5;
    }
  }
  h3 {
    font-size: 1.25rem;
  }
  @media (min-width: ${sizes.medium}) {
    width: calc(100% / 2);
    padding-right: 4rem !important;
    &:nth-child(2n) {
      padding-right: 0 !important;
    }
  }
  @media (min-width: ${sizes.large}) {
    width: calc(100% / 3);
    padding-right: 4rem !important;
    &:nth-child(2n) {
      padding-right: 4rem !important;
    }
    &:nth-child(3n) {
      padding-right: 0 !important;
    }
  }
`
export const Blurb = styled.p`
  width: 100%;
  margin: 0 0 5rem;
  font-size: 1.25rem;
  line-height: 1.3;
  @media (min-width: ${sizes.large}) {
    width: calc(100% / 3 * 2);
    padding-right: 4rem;
  }
  @media (min-width: ${sizes.extraLarge}) {
    width: calc(100% / 3);
    padding-right: 4rem;
  }
`
export const Underline = styled.span`
  background-image: linear-gradient(
    to right,
    ${props => props.theme.colorText} 0%,
    ${props => props.theme.colorText} 100%
  );
  background-repeat: repeat-x;
  background-position: 0 95%;
  background-size: 100% 1px;
`

export const Box = styled.div`
  width: 100%;
  background: white;
  max-width: ${({ width }) => (width === 'full' ? 'auto' : '44rem')};
  color: ${({ theme }) => theme.colorText};
  align-self: ${({ align }) => align};
  ${({ shadow }) => shadow && 'box-shadow: 0 0 1.5rem rgba(0,0,0,0.15);'}
`

export const Wrapper = styled.div`
  max-width: ${({ width }) => (width === 'full' ? 'auto' : '100rem')};
  /* margin: ${({ width }) => (width === 'full' ? '0 auto' : '1rem')}; */
  margin: 0 auto;
  position: relative;
  z-index: ${({ z }) => z || 1};
  display: flex;
  flex-direction: column;
  background: ${({ bg }) => bg || 'transparent'};
  @media (min-width: ${sizes.medium}) {
    padding: ${({ width }) => (width === 'full' ? '0' : '0 4rem')};
  }
`

export const Top = styled.div`
  background: white;
  font-size: ${({ size }) => (size === 'big' ? '2.75rem' : '0.75rem')};
  font-weight: ${({ size }) => (size === 'big' ? 400 : 600)};
  text-transform: ${({ size }) => (size === 'big' ? 'none' : 'uppercase')};
  letter-spacing: 0.03em;
  line-height: 1.3;
  padding: ${({ size }) => (size === 'big' ? '2rem 4rem 1rem' : '1rem 4rem')};
  border-bottom: 1px solid;
  ${({ bt }) =>
    bt &&
    `
    border-top: 1px solid;
    transform: translateY(-1px);
  `};
  @media (max-width: ${sizes.medium}) {
    font-size: ${({ size }) => (size === 'big' ? '2rem' : '0.75rem')};
    padding: ${({ size }) => (size === 'big' ? '2rem 2rem 1rem' : '1rem 2rem')};
  }
`
export const Tag = styled.p`
  font-size: 4rem;
  line-height: 1.1;
  padding: 2rem 4rem;
  font-weight: 300;
  display: flex;
  align-items: center;
  justify-content: space-between;
  button {
    -webkit-appearance: none;
    -moz-appearence: none;
    border: 0;
    background: ${props => props.theme.colorText};
    text-transform: uppercase;
    color: white;
    font-size: 1.5rem;
    padding: 0.25rem 1rem;
    &:after {
      margin-left: 0.333em;
      content: '→';
    }
    &:hover,
    &:focus {
      opacity: 0.7;
      cursor: pointer;
    }
  }
  @media (max-width: ${sizes.medium}) {
    font-size: 3rem;
    padding: 2rem;
    button {
      font-size: 1rem;
    }
  }
`

export const SearchContainer = styled.div`
  background: white;
  width: 100%;
  ${({ isSticky }) =>
    isSticky &&
    `
    border-left: 1px solid;
    @media (max-width: ${sizes.extraLarge}) {
      width: 75%;
    }
    @media (max-width: ${sizes.large}) {
      width: 50%;
    }
  `}
`

export const ProgramList = styled.ul`
  padding: 0;
  margin: 0;
  margin-top: 1rem;
  list-style: none;
  font-size: 1rem;
  li {
    display: inline;
    padding: 0;
    margin: 0;
    &:before {
      content: ' ⚬ ';
    }
    &:last-of-type {
      &:after {
        content: ' ⚬ ';
      }
    }
  }
`
